export const forWhomItems: string[] = [
  'Tenés más de 60 años y sentís que la panza creció sin que puedas controlarla',
  'Nunca entrenaste y los ejercicios normales te parecen difíciles o peligrosos',
  'Querés empezar a moverte pero sin riesgo de lastimarte ni agotarte',
  'Extrañás sentirte liviana, activa y con energía durante el día',
  'Querés una rutina simple que puedas hacer en casa, a tu ritmo',
  'Buscás volverte a sentir bien con tu cuerpo sin dietas imposibles',
]

export type Module = {
  number: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Respiración y activación',
    description:
      'Cómo respirar para activar el metabolismo, reducir la inflamación abdominal y calmar el sistema nervioso.',
  },
  {
    number: '02',
    title: 'Movimientos Tai Chi en silla',
    description:
      'Secuencias suaves de tai chi adaptadas a la silla para mejorar el equilibrio, la circulación y quemar calorías sin impacto.',
  },
  {
    number: '03',
    title: 'Yoga abdominal sentada',
    description:
      'Posturas específicas de yoga para fortalecer el abdomen, aflojar la tensión lumbar y estimular la digestión.',
  },
  {
    number: '04',
    title: 'Rutina diaria de 15 minutos',
    description:
      'Una secuencia completa lista para hacer cada mañana que combina todo lo aprendido en un solo flujo continuo.',
  },
  {
    number: '05',
    title: 'Alimentación consciente 60+',
    description:
      'Pequeños cambios en la alimentación que complementan el movimiento y potencian la reducción de la panza.',
  },
  {
    number: '06',
    title: 'Plan de progreso semanal',
    description:
      'Cómo avanzar semana a semana sin frustrarte, midiendo los cambios reales en tu cuerpo y en tu energía.',
  },
]

export type Bonus = {
  tag: string
  isMain?: boolean
  title: string
  description: string
  footnote: string
  image?: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Producto principal',
    isMain: true,
    title: 'Libro Digital Vientre Ligero 60+',
    description:
      'Guía completa de yoga y tai chi en silla con rutinas, explicaciones y fotos paso a paso. Todo el programa en tus manos.',
    footnote: 'Descarga inmediata en PDF',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/87990afa-45f1-4097-b897-046a45d14a20.jpg',
  },
  {
    tag: 'Además te llevás',
    title: 'Plantilla de 50 Ejercicios dividida en 4 semanas',
    description:
      'Los 50 movimientos organizados semana por semana, listos para imprimir. Ya sabés qué hacer cada día, sin tener que pensarlo.',
    footnote: 'Imprimible · Organizado en 4 semanas',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6b20ce57-a03c-40a7-95dd-9f09367024cb.jpg',
  },
  {
    tag: 'Bono #1',
    title: 'Guía de postura y respiración para vientre más firme',
    description:
      'Cómo sentarte, sostener el abdomen y respirar correctamente para que cada movimiento trabaje la zona media y tu panza se vea más firme desde el primer día.',
    footnote: 'PDF con guía paso a paso',
  },
  {
    tag: 'Bono #2',
    title: 'Plan de 15 minutos diarios para no abandonar',
    description:
      'Un plan simple con horarios y recordatorios para convertir los 15 minutos en un hábito que no se corta a la semana de empezar.',
    footnote: 'Imprimible · Fácil de seguir',
  },
  {
    tag: 'Bono #3',
    title: 'Mini rutina para días con molestias leves',
    description:
      'Una secuencia extra suave para los días en que te duele la espalda, las rodillas o estás cansada, y así nunca perder la constancia.',
    footnote: 'Movimientos de bajísimo impacto',
  },
]

export const checkoutUrl =
  'https://yoga-y-tai-chi-en-silla.impultienda.ar/checkout'

export const price = {
  amount: '25.999',
  currency: '$',
  note: 'Pago único · Acceso de por vida',
}

export const priceIncludes: string[] = [
  'Libro Digital Vientre Ligero 60+ (6 módulos)',
  'Plantilla de 50 ejercicios dividida en 4 semanas',
  'Bono #1 — Guía de postura y respiración para vientre más firme',
  'Bono #2 — Plan de 15 minutos diarios para no abandonar',
  'Bono #3 — Mini rutina para días con molestias leves',
]

export type ProgramNumber = {
  value: string
  meaning: string
}

export const programNumbers: ProgramNumber[] = [
  { value: '50', meaning: 'Ejercicios organizados en 4 semanas de programa' },
  { value: "15'", meaning: 'Minutos al día es todo lo que necesitás' },
  { value: '6', meaning: 'Módulos de contenido práctico paso a paso' },
  { value: '5', meaning: 'Recursos descargables incluidos en tu compra' },
]

export const whyItWorksPoints: string[] = [
  'Sin ejercicio de alto impacto ni riesgo de lesiones',
  'Podés hacerlo en casa, en pijama, en cualquier momento',
  'No necesitás ningún equipo ni experiencia previa',
  'Resultados visibles desde las primeras semanas',
  'Mejora también el sueño, la postura y el estado de ánimo',
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/8a48e275-ca12-4192-a055-1770aec311d5.jpg',
  quote:
    'https://cdn.magicpatterns.com/patterns/generated-images/ac015fda-dac8-4641-b73d-7294a27ff5ae.jpg',
}
